export function Debounce(duration = 0, mode = 'timer') {
    return (target, name, descriptor) => {
        const fn = descriptor.value;
        if (typeof fn !== 'function') {
            throw new Error('[Debounce]: support to decorate functions only.');
        }
        let timer = null;
        let pre = 0;
        if (mode === 'timestamp') {
            descriptor.value = function (...args) {
                const now = Date.now();
                if (now - pre > duration) {
                    fn.apply(this, args);
                }
                pre = now;
            };
        }
        else if (mode === 'timer') {
            descriptor.value = function (...args) {
                if (timer) {
                    window.clearTimeout(timer);
                }
                timer = setTimeout(() => {
                    timer = null;
                    fn.apply(this, args);
                }, duration);
            };
        }
        else {
            throw new Error('[Debounce]: unknown mode.');
        }
        return descriptor;
    };
}
